const onClickContactUs = () => {
  window.location.href = "mailto:contact@guardhash.com";
};

export default onClickContactUs;
